import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const DAY_TYPE_COLORS = {
  snc: "#F97316",
  sports_skill: "#3B82F6",
  travel: "#A855F7",
  match: "#EAB308",
  rest: "#6B7280",
  recovery: "#14B8A6",
};

export const DAY_TYPE_LABELS = {
  snc: "SNC",
  sports_skill: "Sports Skill",
  travel: "Travel",
  match: "Match",
  rest: "Rest",
  recovery: "Recovery",
};

export const TASK_CLASS_LABELS = {
  mind: "Mind",
  snc: "SNC",
  drills: "Drills",
  nutrition: "Nutrition",
  physio: "Physio",
  medical: "Medical",
};

export const ROLE_LABELS = { admin: "Admin", coach: "Coach", athlete: "Athlete" };
